import RegistrationImageCarousel from './RegistrationImageCarousel';

export default RegistrationImageCarousel;
